module.exports = __webpack_public_path__ + "img/screenshot-ontploffing.62a54951.png";